var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('layout-header'),_c('div',{staticClass:"layout_body"},[_c('layout-sidebar'),_c('layout-main',[_vm._t("layout-main")],2)],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }